import { List, ListItem, ListItemText, Typography } from "@mui/material";

import { ExpandedEcrAssignmentRow } from "api/memberPortal/reports/expandedEcrAssignment/expandedEcrAssignment.types";

const TechTypeCell = ({
  row: { tech_type },
}: {
  row: ExpandedEcrAssignmentRow;
}) => {
  const techTypeArr = tech_type ? tech_type.split(",") : [];
  return (
    <List sx={{ padding: "0" }}>
      {techTypeArr.map((techType: string) => (
        <ListItem key={techType}>
          <ListItemText
            sx={{ margin: "0", typography: "caption" }}
            // WARN: Custom styling from pre standardization!
            // TODO: Standardize when you come across this!
            primary={<Typography variant="caption">{techType}</Typography>}
          />
        </ListItem>
      ))}
    </List>
  );
};

export default TechTypeCell;
